<script lang="ts">
	//Design system components
	import { Alert, Button, Container, Radio, Text } from '@Shelly/shelly-design-system';
	//Configs
	import { devices_config } from '@devices/index';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { get_mode, real_id } from 'src/helpers/interface_helpers';
	import { genCharArray } from 'src/helpers/utilities';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	import {
		getDeviceStatus,
		readDeviceSettings,
		readDeviceStatus,
	} from 'src/stores/device-runtime/status-selectors';

	$: statusStore = getDeviceStatus(device.id);
	export let device;

	let loading = false;
	const mode = get_mode(device, readDeviceSettings(device.id), readDeviceStatus(device.id));

	const phasesNUmber = devices_config[device.type]?.modes?.[mode]?.phases;
	const phases = genCharArray(phasesNUmber);
	let phaseFrom = phases[0];
	let phaseTo = phases[1];

	$: phaseTo === phaseFrom && phases.indexOf(phaseFrom) !== 0
		? (phaseTo = phases[0])
		: phaseTo === phaseFrom && phases.indexOf(phaseFrom) === 0
			? (phaseTo = phases[1])
			: ''; //prevent same phases calibration

	const selectPhaseFrom = (phase) => {
		phaseFrom = phase;
	};
	const selectPhaseTo = (phase) => {
		phaseTo = phase;
	};

	const setCalibration = async () => {
		loading = true;
		const res = await gen2Request(device, 'EM.PhaseToPhaseCalib', {
			id: 0,
			from: phaseFrom,
			to: phaseTo,
		});

		await onSettingsResponse(res, device);
		if (!res.isok) {
			//Pako-ToDO need to handle errors maybe in a global level. Also those two has same code but different message
			//                {
			//   "code": -110,
			//   "message": "verify power"
			// }
			// {code: -110, message: "verify current, reset device."}
		}
		loading = false;
	};
</script>

<Alert
	class="mb-m"
	heading={$format('heading_phase_to_phase', {
		default: 'Phase to phase calibration',
	})}
	message={$format('calibrate_phases_description', {
		default:
			'In order to be able to calibrate correctly the phase voltages need to be equal i.e. if we calibrate a CT from Channel 0 to a CT on Channel 1, the voltage of Channel 0 and Channel 1 needs to be the same. A minimum load is required for successful phase to phase calibration.',
	})}
/>

<Container class="mb-s">
	<Text class="mb-m" styleType="h2"
		>{$format('emeter_calibrate_phase', { default: 'Calibrate phase:' })}</Text
	>
	{#each phases.concat('n') as phase}
		<Radio
			class="mb-s"
			size="m"
			selected={phaseTo}
			value={phase}
			disabled={phaseFrom === phase || loading}
			on:click={() => selectPhaseTo(phase)}
			id="radio-y7ebd20">{$format(`label_phase_${phase}`, { default: `Phase ${phase}` })}</Radio
		>
	{/each}
</Container>
<Container class="mb-s">
	<Text class="mb-m" styleType="h2">{$format('calibrate_phase_from', { default: 'From phase:' })}</Text
	>
	{#each phases as phase}
		<Radio
			class="mb-s"
			size="m"
			selected={phaseFrom}
			value={phase}
			disabled={loading}
			on:click={() => selectPhaseFrom(phase)}
			id="radio-5g9hgg0">{$format(`label_phase_${phase}`, { default: `Phase ${phase}` })}</Radio
		>
	{/each}
</Container>

<Button {loading} width="full" size="m" on:click={setCalibration}>{$format('button_calibrate')}</Button>
